import cn from 'classnames'
import Link from 'components/Link'
import { trackMarketingAction } from './events'
import { useActiveAnchor } from './useActiveAnchor'
import styles from './JumpNav.module.scss'

interface JumpNavProps {
  slug: string
  items: { copy: string; anchor: string }[]
  className?: string
}

export const JumpNav = ({ slug, items, className }: JumpNavProps) => {
  const { activeAnchor } = useActiveAnchor(items.map((i) => i.anchor))

  const renderItems = () =>
    items.map(({ copy, anchor }) => (
      <Link
        className={cn(
          styles.Item,
          {
            [styles.ItemActive]: anchor === activeAnchor,
            'mc-px-4 mc-px-sm-9': items.length >= 4,
            'mc-px-4 mc-px-xs-6 mc-px-sm-9': items.length < 4,
          },
          'd-flex flex-column justify-content-center align-items-center col-auto',
        )}
        href={`#${anchor}`}
        key={anchor}
        onClick={trackMarketingAction(copy, slug)}
        isBasic
      >
        {copy}
      </Link>
    ))

  return (
    <nav className={`${styles.JumpNav} ${className} uncontainer mc-pt-2`}>
      <div className='d-flex justify-content-center mc-h-100'>
        {renderItems()}
      </div>
    </nav>
  )
}
